export default __webpack_public_path__ + "static/media/model-planes-1566822_1920.198c96d2.jpg";